import { BookOpen, Users } from "lucide-react";
import TM from "@/components/TM";

export const TRY_ROLES = [
  { id: "student", label: "Student Experience", icon: BookOpen, desc: "Experience the learning flow, just like a real session" },
  { id: "full", label: "Full Experience", icon: Users, desc: "See the student journey and live teacher insights — both sides" },
];

export default function TryRoleSelect({ onSelect }) {
  return (
    <div className="w-full max-w-2xl mx-auto text-center relative z-10" data-testid="try-role-select">
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-white leading-tight mb-3">
        Try Mitraa<TM />
      </h1>
      <p className="text-lg mb-10" style={{ color: "rgba(176, 219, 255, 0.92)" }}>
        What would you like to see?
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {TRY_ROLES.map(({ id, label, icon: Icon, desc }) => (
          <button
            key={id}
            onClick={() => onSelect(id)}
            data-testid={`try-role-card-${id}`}
            className="group text-left p-7 rounded-2xl border-2 border-white/15 bg-white/5 hover:bg-white/10 hover:border-sky-400/60 transition-all"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4 bg-sky-500/20 group-hover:bg-sky-500/30 transition-colors">
              <Icon className="w-6 h-6 text-sky-300" />
            </div>
            <div className="font-display text-lg font-semibold text-white mb-1">{label}</div>
            <div className="text-sm" style={{ color: "rgba(176, 219, 255, 0.75)" }}>{desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
